import { Container as PixiContainer } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { Container } from '@pixi/react'
import { tableService } from '../domain/table/tableService'

interface UpperReelsProps {
  x: number
  y: number
}

export const UpperReels = ({ x = 0, y = 0 }: UpperReelsProps) => {
  const upperReelsRef = useRef<PixiContainer>()
  useEffect(() => {
    if (upperReelsRef.current) {
      tableService.setUpperContainer(upperReelsRef.current as PixiContainer)
    }
  }, [])
  return (
    <Container
      visible={true}
      name="UpperReelsContainer"
      position={[x, y]}
      ref={(el: PixiContainer | null) => {
        upperReelsRef.current = el as PixiContainer
      }}
    >
    </Container>
  )
}

export const UpperReels2 = ({ x = 0, y = 0 }: UpperReelsProps) => {
  const upperReelsRef = useRef<PixiContainer>()
  useEffect(() => {
    if (upperReelsRef.current) {
      tableService.setUpperContainer2(upperReelsRef.current as PixiContainer)
    }
  }, [])
  return (
    <Container
      visible={true}
      name="UpperReelsContainer2"
      position={[x, y]}
      ref={(el: PixiContainer | null) => {
        upperReelsRef.current = el as PixiContainer
      }}
    >
    </Container>
  )
}
